"use strict";

import angular from "angular";
import "./themes/request-confirm-analysis-plus-dialog.scss";
import "./themes/request-confirm-analysis-plus-dark.scss";

class RequestConfirmAnalysisPlusDialogCtrl {
    constructor(locals, $mdDialog) {
        this.locals = locals;
        this.$mdDialog = $mdDialog;
    }

    $onInit() {}
}

RequestConfirmAnalysisPlusDialogCtrl.$inject = ["locals", "$mdDialog"];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("RequestConfirmAnalysisPlusDialogCtrl", RequestConfirmAnalysisPlusDialogCtrl);
